import React from 'react';
import MockCancelOrRefundComponent from './MockCancelOrRefundComponent/MockCancelOrRefundComponent';
import MockIssuedComponent from './MockIssuedComponent/MockIssuedComponent';
import MockInformationGatheringComponent from './MockInformationGatheringComponent/MockInformationGatheringComponent';
import MockErrorComponent from './MockErrorComponent/MockErrorComponent';

class MockCancelOrRefundFlowComponent extends React.Component {
  componentDidMount() {
    if (!this.props.zendeskCancelDropdownId || !this.props.zendeskRefundDropdownId) {
      this.props.setPageState('error');
    } else {
      this.props.setPageState('policy');
    }
  }

  render() {
    const {
      pageState,
      selectedOrder,
      selectedConfig,
      selectedTask,
      setSelectedTask,
      setPageState,
      policy,
      hydrateZendeskDropdowns,
      businessId,
      zendeskDomain,
      zendeskCancelDropdownId,
      zendeskRefundDropdownId,
      updateTicketFields,
      dropdownItems,
      selectedTicket,
      expertId,
    } = this.props;
    switch (pageState) {
      case 'policy':
        return (
          <MockInformationGatheringComponent
            pageState={pageState}
            selectedOrder={selectedOrder}
            shopifyConfig={selectedConfig}
            setSelectedTask={setSelectedTask}
            setPageState={setPageState}
            selectedTask={selectedTask}
            policy={policy}
            hydrateZendeskDropdowns={hydrateZendeskDropdowns}
            businessId={businessId}
            zendeskDomain={zendeskDomain}
            zendeskCancelDropdownId={zendeskCancelDropdownId}
            zendeskRefundDropdownId={zendeskRefundDropdownId}
          />
        );
      case 'options':
        return (
          <MockCancelOrRefundComponent
            pageState={pageState}
            setPageState={setPageState}
            updateTicketFields={updateTicketFields}
            zendeskDomain={zendeskDomain}
            dropdownItems={dropdownItems}
            selectedTicket={selectedTicket}
            selectedTask={selectedTask}
            expertId={expertId}
            zendeskCancelDropdownId={zendeskCancelDropdownId}
            zendeskRefundDropdownId={zendeskRefundDropdownId}
          />
        );
      case 'issued':
        return <MockIssuedComponent setSelectedTask={setSelectedTask} selectedTask={selectedTask} />;
      case 'error':
        return <MockErrorComponent setSelectedTask={setSelectedTask} />;
      default:
        throw new Error(`Unexpected currentPage value: ${pageState.currentPage}`);
    }
  }
}

export default MockCancelOrRefundFlowComponent;
